import {ReelsBasicState} from '@gongxigames/framework/slot/modules/reels/states/ReelsBasicState';
import {ReelsModule} from '@gongxigames/framework/slot/modules/reels/ReelsModule';
import {SpinButtonEvents} from '@gongxigames/framework/slot/modules/spinbutton';

export class FirecatcherReelsBasicState extends ReelsBasicState {

    protected setupEvents(): void {
        this.setEventHandler(SpinButtonEvents.SPIN_BUTTON_PRESSED, this.onSpinStartedByButton.bind(this));
    }

    protected onSpinStartedByButton(): void {
        if (!this.module.canSpinBySpinButton) {
            return;
        }

        this.updateReelStripWithPositions();
        this.module.gotoState(ReelsModule.RESPIN_SPINNING_STATE);
    }
}
